import { Link } from "react-router-dom";
import SearchInput from "./SearchInput";
import logoImage from "../../assets/images/logo.svg";

const Navbar = () => {
  return (
    <nav className="container relative py-3">
      <div className="flex items-center justify-between">
        <Link to="/">
          <img src={logoImage} alt="logo" />
        </Link>

        <SearchInput />
      </div>
    </nav>
  );
};

export default Navbar;
